import $ from 'jquery';
import Robust from './Robust';

class VariationPrice extends Robust {
	constructor() {
		super();
		this.init();
	}

	init() {
		if (!this.selfDom()) return;
		this.events();
	}

	selfDom() {
		if (!this.$body.hasClass('single-product')) return false;

		this.$variationWrap = $('.single_variation_wrap');
		this.$variationPriceReley = $('<div>', {class: 'variation-price-reley'});
		this.$productPrice = $('.product-summary-price .price').filter(':first');

		return (
			this.$variationWrap.length > 0 &&
			this.$productPrice.length > 0
		);
	}

	events() {
		this.$variationWrap.off('show_variation.VariationPrice, hide_variation.VariationPrice');
		this.$variationWrap.on(
			'show_variation.VariationPrice, hide_variation.VariationPrice',
			this.setPriceVisibilityHandler.bind(this)
		);
	}

	setPriceVisibilityHandler(evt , variation) {
		const $variationPrice = this.$variationWrap.find('.woocommerce-variation-price');
		const $singleVariation = this.$variationWrap.find('.woocommerce-variation');
		// const $tieredWrapper = this.$variationWrap.find('.tiered-pricing-dynamic-price-wrapper');
		
		$singleVariation.stop(true, true);

		
		if (typeof variation !== 'undefined' && variation.price_html) {
			this.$productPrice.hide();
			$variationPrice.hide();
			this.$variationPriceReley.html(variation.price_html);
			this.$variationPriceReley.insertBefore(this.$productPrice);

		} else {
			this.$variationPriceReley.detach();
			this.$productPrice.show();
			$variationPrice.show();
		}

		// if($tieredWrapper.length > 0) {
		// 	this.$variationWrap.find('.woocommerce-variation-price').hide();
		// 	this.$productPrice.show();
		// }

		// setTimeout(() => {
		// 	$singleVariation.find('.variable-price-label');
		// }, 200);
	}
}

export default VariationPrice;